<script>
  import ConversationTile from "../Components/ConversationTile.svelte";
  import SmsNumberInfo from "../Components/SmsNumberInfo.svelte";
  import InfiniteScroll from "@shared/svelte/Components/InfiniteScroll/Element.svelte";
  import { onMount } from "svelte";

  export let searchQuery;
  export let callbacks;
  export let conversations;
  export let currentConversation;
  export let pagination;
  export let openNewMessageModal;
  export let changeConversationWrapper;
  export let smsPhoneNumber;
  export let hasSalesReps;

  $: childProps = {
    currentConversation: currentConversation,
    changeConversationWrapper: changeConversationWrapper,
  };

  function searchMessages(event) {
    searchQuery = event.target.value;
    callbacks.search(searchQuery);
  }

  onMount(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const salesRepIdParam = urlParams.get("sales_rep_id");
    if (salesRepIdParam) callbacks.changeConversation([salesRepIdParam]);
  });

</script>

<div
  class="grid-row grid-container-header grid-container-header-fixed padding--small fizz-space-between"
>
  <div>
    <span class="default-title--bold">Messages</span>
    <SmsNumberInfo {smsPhoneNumber} />
    <button
      class="button button--primary float-right"
      on:click={openNewMessageModal}
      disabled={!hasSalesReps}
    >
      New Message
    </button>
  </div>
</div>
<div class="grid-row grid-container-middle padding--small">
  <div class="input-wrapper full-width">
    <input
      class="input"
      placeholder="Search Messages"
      on:change={searchMessages}
      value={searchQuery}
      type="text"
    />
  </div>
</div>
{#if conversations.length == 0}
  <div
    class="grid-row grid-container-middle background-white empty-left-pane secondary-body--bold align-center padding-top--medium"
  >
    {#if searchQuery}
      <div class="grid-col">Nothing matches your search!</div>
    {:else}
      <div class="grid-col">You don't have any messages</div>
    {/if}
  </div>
{:else}
  <div class="grid-row cursor-pointer border-bottom background-white">
    <InfiniteScroll
      {callbacks}
      {pagination}
      items={conversations}
      additionalProps={childProps}
      scrollElementId={"chat-messages-container"}
      itemComponent={ConversationTile}
    />
  </div>
{/if}
